module.exports = __webpack_public_path__ + "static/img/headimag1.c922ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/headimag1.jpg
// module id = 1tMd
// module chunks = 0